import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'anatoliapps-angular/services';

import { Notification, NotificationDetails } from 'hakikat/models';
import { PaginatedResult } from 'hakikat/shared';
import { API_CONFIG } from 'hakikat/utils';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends ApiService {

  //#region Endpoints
  readonly #NOTIFICATIONS_ENDPOINT = 'notification';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  public getNotifications(): Observable<PaginatedResult<Notification>> {
    return this.get<PaginatedResult<Notification>>(`${this.#NOTIFICATIONS_ENDPOINT}`);
  }

  public getNotificationDetails(id: string): Observable<NotificationDetails> {
    return this.get<NotificationDetails>(`${this.#NOTIFICATIONS_ENDPOINT}/${id}`);
  }
  //#endregion
  
}
